import {ComponentProps, FC} from 'react';

type IconProps = Omit<ComponentProps<'svg'>, 'color'> & {
    size?: number;
    variant?: 'stroke' | 'solid';
};

export const IconLive: FC<IconProps> = ({
    size = 24,
    width = size,
    height = size,
    variant = 'stroke',
    ...rest
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
    >
        {variant === 'solid' ? (
            <path
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19.2881 5C21.3263 5.00013 22.9785 6.79094 22.9785 9V15C22.9785 17.2091 21.3263 18.9999 19.2881 19H4.66895C2.63076 18.9999 0.978516 17.2091 0.978516 15V9C0.978516 6.79094 2.63076 5.00013 4.66895 5H19.2881ZM5.5 9.5C5.22386 9.5 5 9.72386 5 10V14C5 14.2761 5.22386 14.5 5.5 14.5H7.5C7.77614 14.5 8 14.2761 8 14C8 13.7239 7.77614 13.5 7.5 13.5H6V10C6 9.72386 5.77614 9.5 5.5 9.5ZM9.5 9.5C9.22386 9.5 9 9.72386 9 10V14C9 14.2761 9.22386 14.5 9.5 14.5C9.77614 14.5 10 14.2761 10 14V10C10 9.72386 9.77614 9.5 9.5 9.5ZM14.6533 9.52441C14.3906 9.43994 14.1091 9.58403 14.0244 9.84668L13 13.0322L11.9756 9.84668C11.8909 9.58405 11.6094 9.43997 11.3467 9.52441C11.0841 9.60907 10.94 9.89056 11.0244 10.1533L12.3096 14.1533C12.3761 14.3598 12.5682 14.4998 12.7852 14.5H13.2139C13.431 14.5 13.6239 14.36 13.6904 14.1533L14.9756 10.1533C15.0601 9.89056 14.916 9.60908 14.6533 9.52441ZM16.5 9.5C16.2239 9.5 16 9.72386 16 10V14C16 14.2761 16.2239 14.5 16.5 14.5H18.5C18.7761 14.5 19 14.2761 19 14C19 13.7239 18.7761 13.5 18.5 13.5H17V12.5H18.5C18.7761 12.5 19 12.2761 19 12C19 11.7239 18.7761 11.5 18.5 11.5H17V10.5H18.5C18.7761 10.5 19 10.2761 19 10C19 9.72386 18.7761 9.5 18.5 9.5H16.5Z"
            />
        ) : (
            <>
                <path
                    fill="currentColor"
                    d="M5.5 9.5C5.77614 9.5 6 9.72386 6 10V13.5H7.5C7.77614 13.5 8 13.7239 8 14C8 14.2761 7.77614 14.5 7.5 14.5H5.5C5.22386 14.5 5 14.2761 5 14V10C5 9.72386 5.22386 9.5 5.5 9.5Z"
                />
                <path
                    fill="currentColor"
                    d="M9.5 9.5C9.77614 9.5 10 9.72386 10 10V14C10 14.2761 9.77614 14.5 9.5 14.5C9.22386 14.5 9 14.2761 9 14V10C9 9.72386 9.22386 9.5 9.5 9.5Z"
                />
                <path
                    fill="currentColor"
                    d="M14.0244 9.84668C14.1092 9.58422 14.3907 9.43997 14.6533 9.52441C14.9158 9.60912 15.0598 9.8907 14.9756 10.1533L13.6904 14.1533C13.6239 14.3599 13.4309 14.4999 13.2139 14.5H12.7852C12.5682 14.4998 12.3761 14.3598 12.3096 14.1533L11.0244 10.1533C10.9401 9.8906 11.0841 9.60906 11.3467 9.52441C11.6093 9.4402 11.8909 9.58424 11.9756 9.84668L13 13.0322L14.0244 9.84668Z"
                />
                <path
                    fill="currentColor"
                    d="M18.5 9.5C18.7761 9.5 19 9.72386 19 10C19 10.2761 18.7761 10.5 18.5 10.5H17V11.5H18.5C18.7761 11.5 19 11.7239 19 12C19 12.2761 18.7761 12.5 18.5 12.5H17V13.5H18.5C18.7761 13.5 19 13.7239 19 14C19 14.2761 18.7761 14.5 18.5 14.5H16.5C16.2239 14.5 16 14.2761 16 14V10C16 9.72386 16.2239 9.5 16.5 9.5H18.5Z"
                />
                <path
                    fill="currentColor"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M19.4775 5.00488C21.4277 5.11188 22.9785 6.8598 22.9785 9V15C22.9785 17.1402 21.4277 18.8881 19.4775 18.9951L19.2881 19H4.66895C2.63076 18.9999 0.978516 17.2091 0.978516 15V9C0.978516 6.79094 2.63076 5.00013 4.66895 5H19.2881L19.4775 5.00488ZM4.66895 7C3.88379 7.00014 2.97852 7.74094 2.97852 9V15C2.97852 16.2591 3.88379 16.9999 4.66895 17H19.2881C20.0732 16.9999 20.9785 16.2591 20.9785 15V9C20.9785 7.74094 20.0732 7.00014 19.2881 7H4.66895Z"
                />
            </>
        )}
    </svg>
);
